import { type OrderStatus } from '@/features/shop/services/Orders/types'
import { ORDER_STATUS_TEXTS } from '@/features/shop/components/OrderDetails/OrderDetailsStatus/statuses'

export const pastStatuses: OrderStatus[] = ['delivered', 'cancelled', 'returned']
export const isPastOrderStatus = (status: OrderStatus) => {
  return pastStatuses.includes(status)
}

const upcomingStatuses: OrderStatus[] = [
  'open',
  'shopping',
  'claimed',
  'processed',
  'ready for pickup',
]
export const isUpcomingOrderStatus = (status: OrderStatus) => {
  return upcomingStatuses.includes(status)
}

export const isOutForDeliveryOrderStatus = (status: OrderStatus) => {
  return status === 'processed'
}

export const isDeliveredOrderStatus = (status: OrderStatus) => {
  return status === 'delivered'
}

export const isCancelledOrderStatus = (status: OrderStatus) => {
  const cancelledStatuses: OrderStatus[] = ['cancelled', 'returned']
  return cancelledStatuses.includes(status)
}

export const isReadyForPickupOrderStatus = (status: OrderStatus) => {
  return status === 'ready for pickup'
}

export const isShoppingActiveStatus = (status: OrderStatus) => {
  return status === 'shopping' || status === 'processed'
}

export const getOrderStatusText = (status: OrderStatus, isPickup: boolean): string => {
  switch (status) {
    case 'delivered':
      if (isPickup) {
        return ORDER_STATUS_TEXTS.PICKED_UP
      } else {
        return ORDER_STATUS_TEXTS.DELIVERED
      }
    case 'open':
      return ORDER_STATUS_TEXTS.ORDER_PLACED
    case 'claimed':
      return ORDER_STATUS_TEXTS.ORDER_CLAIMED
    case 'shopping':
      return ORDER_STATUS_TEXTS.SHOP_IN_PROGRESS
    case 'processed':
      return ORDER_STATUS_TEXTS.ON_THE_WAY
    case 'returned':
    case 'cancelled':
      return ORDER_STATUS_TEXTS.ORDER_CANCELLED
    case 'ready for pickup':
      return ORDER_STATUS_TEXTS.READY_FOR_PICKUP
    default:
      return ''
  }
}
